// extracted by mini-css-extract-plugin
module.exports = {"tags":"TagsInput_tags__33Uw0","tagsInputItem":"TagsInput_tagsInputItem__2SI2d","tagsInputItemDelete":"TagsInput_tagsInputItemDelete__2MPeP","item":"TagsInput_item__3nL9f"};